import axios from "axios";
import {Base64} from "js-base64";

export async function loadImageToDataUrl(imageUrl) {
  let client = axios.create();
  let response;
  try {
    response = await client.get(imageUrl, {responseType: "arraybuffer",});
  } catch {
    response = await client.get(imageUrl, {
      responseType: "arraybuffer",
      headers: {
        "Cache-Control": "no-cache, no-store, must-revalidate",
        "Pragma": "no-cache",
        "Expires": "0",
      }
    });
  }
  let imageType = response.headers['content-type'];
  let base64 = Base64.fromUint8Array(new Uint8Array(response.data));
  return `data:${imageType};base64,${base64}`;
}
